import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {getRegisteredComponent} from "../../Utility/reactHelpers";
import {getSiteComponent} from "../../Utility/componentRegistry";
import ClassicProductGallery from "../classic/ClassicProductGallery";
import Embiggener from "../embiggener/Embiggener";
import scrapyardSlice from "../../ReduxStore/scrapyardSlice";
import dayjs from 'dayjs';
import CatchErrors from "../../Utility/CatchErrors";

export default function ProductImagesContainer({
  dispatch, images,
  productGroup,
  // cartCode, groupId, pageType, groupProperties, pageConfig // from group_page_app_properties
  ...props
}) {
  const [selectedImage, setSelectedImage] = useState(images[0]);
  const [embiggened, setEmbiggened] = useState(false);

  const callbacks = {setSelectedImage, setEmbiggened};

  useEffect(() => {
    let now = dayjs().format("HH:mm:ss");
    let payload = embiggened ? {popupType: 'groupImages', at: now} : null;

    dispatch(scrapyardSlice.actions.setItems({
      popupOpen: payload
    }));
  }, [embiggened]);

  const UI = getSiteComponent('ProductImagesGallery', ClassicProductGallery);

  return <CatchErrors>
    <UI {...props}
      embiggened={embiggened}
      selectedImage={selectedImage}
      callbacks={callbacks}
      productGroup={productGroup}
      images={images}
    />
    {embiggened && <Embiggener {...props}
      selectedImage={selectedImage}
      callbacks={callbacks}
      productGroup={productGroup}
      images={images}/>}
  </CatchErrors>;
}
